"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const gs_1 = require("@ivanlog/gs");
const AppVX_1 = require("./classes/AppVX");
const tmplsInj_1 = require("./plusx-lib/com/tmplsInj");
const App_1 = require("./plusx-lib/App");
const AppControllerBase_1 = require("./plusx-lib/controllers/AppControllerBase");
const GUIControllerBase_1 = require("./plusx-lib/controllers/GUIControllerBase");
const Web3ControllerBase_1 = require("./plusx-lib/controllers/Web3ControllerBase");
gs_1.FormGS.TagClassName = 'px-form';
gs_1.WrapperGS.ExtendComponentsByTagClass(gs_1.FormGS);
(0, tmplsInj_1.InjectComponents)();
AppControllerBase_1.AppControllerBase;
GUIControllerBase_1.GUIControllerBase;
Web3ControllerBase_1.Web3ControllerBase;
new App_1.App("");
globalThis.app = new AppVX_1.AppVX();
globalThis.app.startAsync();
//# sourceMappingURL=index.js.map